import { waitForDom } from './wait-for-dom.js';

const loadScript = async (srcUrl, scriptId, preload = false) => {
  await waitForDom();
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('type', 'text/javascript');
  scriptTag.setAttribute('charset', 'utf-8');
  scriptTag.setAttribute('src', srcUrl);
  scriptTag.setAttribute('async', '');
  if (preload) {
    scriptTag.setAttribute('rel', 'preload');
  }
  if (scriptId) {
    scriptTag.setAttribute('id', scriptId);
  }
  document.getElementsByTagName('body')[0].appendChild(scriptTag);
  return scriptTag;
};

export { loadScript };
